import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import {FunctionsService} from "../services/functions.service";


@Component({
    selector: 'app-accommodation-list',
    templateUrl: './accommodation-list.component.html'
})
export class AccommodationListComponent implements OnInit {

    public slug;

    banner_image = './assets/images/banners/stay-banner.jpg';
    banner_text = '<p>Thanks to the city’s wide selection of hotels, business and leisure travelers alike have plenty of options when it comes to finding a place to lay their heads in Hanoi. Choose from cozy mid-range guest houses, private 5 room boutique villas, contemporary luxury hotels, and everything in between. </p>' +
        '<p>Those who value a central location will do well to look at options in the Old Quarter or West Lake area, while the outlying Tay Ho District boasts a number of international hotel brands. Conveniently located near many of Hanoi’s top tourist attractions, the nearby Ba Dinh district also offers travelers plenty of options in the way of mid-range hotels, but if it’s luxury you seek then nothing compares to the French Quarter’s deluxe options, set amongst the elegant colonial architecture and grand tree lined boulevards.</p>';
    banner_title = 'Stay';

    category = {
        id: '',
        title: '',
        content: '',
        cover_image: ''
    };
    accommodations = [];

    regions = [];
    allRegions: Array<any>;
    regionsPart: Array<any>;
    regionCollapsed: boolean;
    regionHasMore: boolean;

    categories = [];
    allCategories: Array<any>;
    categoriesPart: Array<any>;
    categoryCollapsed: boolean;
    categoryHasMore: boolean;

    facilityGroups = [];
    allFacilities: Array<any>;
    facilitiesPart: Array<any>;

    checked_categories = [];
    selected_regions = '';
    selected_facilities = '';
    selected_categories = '';

    max_price = 100000000;
    price_start = 0;
    price_end = 'end';

    next = null;

    constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private http: HttpClient, public _auth: AuthService) {
        this.allRegions = [];
        this.regionsPart = [];
        this.regionCollapsed = true;
        this.allCategories = [];
        this.categoriesPart = [];
        this.categoryCollapsed = true;
        this.allFacilities = [];
        this.facilitiesPart = [];
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.next = null;
            if (params.slug) {
                this.slug = params['slug'];
                this.checked_categories.push(params['slug']);
                this.http.get(Conf.API_URL + '/category-for-accommodation/?slug=' + this.slug).subscribe(
                    data => {
                        this.category = data['results'][0];
                        this.selected_categories = this.category.id;
                        this.getRegions();
                        this.getCategories();
                        this.getFacilityGroups();
                        this.getAccommodation();
                    },
                    error => {
                        console.log(error.error)
                    }
                );
            } else {
                this.getRegions();
                this.getCategories();
                this.getFacilityGroups();
                this.getAccommodation();
            }
        });
        this.getMaxPrice();
    }

    getMaxPrice() {
        this.http.get(Conf.API_URL + '/accommodation-max-price/').subscribe(
            data => {
                this.max_price = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    selectCategory(slug) {
        this.slug = slug;
        if (this.checked_categories.indexOf(slug) === -1) {
            this.checked_categories.push(slug);
        } else {
            this.checked_categories.splice($.inArray(slug, this.checked_categories), 1);
        }
        this.selected_categories = $('input[name="category"]:checked').map(function () {
            return $(this).val();
        }).get().join(',');
        this.getCategory()
    }

    getCategory() {
        this.http.get(Conf.API_URL + '/category-for-accommodation/?slug=' + this.slug).subscribe(
            data => {
                this.category = data['results'][0];
                this.getRegions();
                this.getCategories();
                this.getFacilityGroups();
                this.getAccommodation();
            },
            error => {
                console.log(error.error)
            }
        );
    }


    getRegions() {
        this.http.get(Conf.API_URL + '/get-joined-areas/?category=accommodations').subscribe(
            data => {
                this.allRegions = data['results'];
                this.regionHasMore = this.allRegions.length > 10;
                this.regionsPart = JSON.parse(JSON.stringify(this.allRegions)).slice(0, 10);
                this.regions = this.regionsPart;
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getCategories() {
        this.http.get(Conf.API_URL + '/category-for-accommodation/?show_all&count=0').subscribe(
            data => {
                this.allCategories = data['results'];
                this.categoryHasMore = this.allCategories.length > 10;
                this.categoriesPart = JSON.parse(JSON.stringify(this.allCategories)).slice(0, 10);
                this.categories = this.categoriesPart;

            },
            error => {
                console.log(error.error)
            }
        );
    }

    getFacilityGroups() {
        this.http.get(Conf.API_URL + '/accommodation-facility-groups/?show_all&visible=true&count=0').subscribe(
            data => {
                this.allFacilities = data['results'];
                this.allFacilities.forEach(group => {
                    if (group.facilities.length > 10) {
                        group.collapsed = true;
                        group.hasMore = true;
                    }
                });
                this.facilitiesPart = JSON.parse(JSON.stringify(this.allFacilities));
                this.facilitiesPart.forEach(group => {
                    group.facilities = group.facilities.slice(0, 10);
                });
                this.facilityGroups = this.facilitiesPart;
            },
            error => {
                console.log(error.error)
            }
        );
    }

    choseRegion() {
        this.selected_regions = $('input[name="location"]:checked').map(function () {
            return $(this).val();
        }).get().join(',');
        this.getAccommodation();
    }

    choseFacility() {
        this.selected_facilities = $('input[name="facility"]:checked').map(function () {
            return $(this).val();
        }).get().join(',');
        this.getAccommodation();
    }

    choseRange(e) {
        this.price_start = e.from;
        this.price_end = e.to;
        this.getAccommodation();
    }

    getAccommodation() {
        var url = Conf.API_URL + '/accommodations/' +
            '?category=' + this.selected_categories +
            '&facility=' + this.selected_facilities +
            '&location=' + this.selected_regions;

        if (this.price_end !== 'end') {
            url += '&price_start=' + this.price_start + '&price_end=' + this.price_end;
        }

        this.http.get(url).subscribe(
            data => {
                this.accommodations = data['results'];
                this.next = data['next'];

                // console.log(this.accommodations)
            },
            error => {
                console.log(error.error)
            }
        );
    }

    loadMore() {
        this.http.get(this.next).subscribe(
            data => {
                this.accommodations = this.accommodations.concat(data['results']);
                this.next = data['next'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    firstParagraph(html) {
        return FunctionsService.firstParagraph(html)
    }

    showMore(type: string, facilityGroup?): void {
        switch (type) {
            case 'region': {
                this.regions = this.regionCollapsed ? this.allRegions : this.regionsPart;
                this.regionCollapsed = !this.regionCollapsed;
                break;
            }
            case 'category': {
                this.categories = this.categoryCollapsed ? this.allCategories : this.categoriesPart;
                this.categoryCollapsed = !this.categoryCollapsed;
                break;
            }
            case 'facility': {
                if (facilityGroup) {
                    const group = this.allFacilities.filter(fGroup => fGroup.id === facilityGroup.id);
                    if (facilityGroup.collapsed) {
                        facilityGroup.facilities = group[0].facilities;
                        facilityGroup.collapsed = false;
                    } else {
                        facilityGroup.facilities = facilityGroup.facilities.slice(0, 10);
                        facilityGroup.collapsed = true;
                    }
                }
                break;
            }
        }
    }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/accommodation-list/accommodation-list.component.ts